import { usePermissions } from '../../hooks/usePermissions';
import { AccountDeletionDialog } from './AccountDeletionDialog';
import { AccountDeletionWithSubscriptionDialog } from './AccountDeletionWithSubscriptionDialog';

interface AccountDeletionComponentProps {
  open: boolean;
  onClose: () => void;
}

export const AccountDeletionComponent = ({ open, onClose }: AccountDeletionComponentProps) => {
  const { isSoloDriver, hasSubscription } = usePermissions();
  const showModal = open && isSoloDriver;

  if (!showModal) {
    return null;
  }

  if (!hasSubscription) {
    return <AccountDeletionDialog onClose={onClose} />;
  }

  return <AccountDeletionWithSubscriptionDialog onClose={onClose} />;
};
